module.exports = __webpack_public_path__ + "static/media/bags_in_storage.321c2f28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bags_in_storage.svg
// module id = 618
// module chunks = 0